import React from 'react';

import { PricingExperimentProvider } from '~shared/hooks/usePricingExperiments';
import { PackageDataProvider } from '~shared/hooks/usePricingExperience';
import { PricingPageProps } from './types';
import PricingRouter from './router';

const PricingPage = ({ experiments, pricingExperience }: PricingPageProps = {}): JSX.Element => {
  return (
    <PricingExperimentProvider experiments={experiments}>
      <PackageDataProvider pricingExperience={pricingExperience}>
        <PricingRouter />
      </PackageDataProvider>
    </PricingExperimentProvider>
  );
};

export default PricingPage;
